import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  FormControl,
  MenuItem,
  Select,
  Box,
  Typography,
} from 'omaha-design-system';
import { CaretDown } from '@phosphor-icons/react';
import { IRootState } from '../../../store/reducer';
import { getPropsLeagueOptions } from '../data/leagueConfig';

interface PropsSportsDropdownProps {
  size?: 'small' | 'medium';
}

interface SportOption {
  value: string;
  label: string;
  disabled: boolean;
}

const SPORTS_OPTIONS: SportOption[] = getPropsLeagueOptions();

const PropsSportsDropdown: React.FC<PropsSportsDropdownProps> = ({ size = 'small' }) => {
  const history = useHistory();
  const filters = useSelector((state: IRootState) => state.stokasticProps.filters);
  const selectedSport = filters.league;

  const handleLeagueChange = (league: string) => {
    // Navigate to the new league URL - the URL sync will update Redux state
    history.push(`/props/${league}`);
  };

  return (
    <FormControl size={size} sx={{ minWidth: 80 }}>
      <Select
        value={selectedSport}
        onChange={(e) => handleLeagueChange(e.target.value as string)}
        displayEmpty
        IconComponent={(props) => (
          <CaretDown
            {...props}
            size={16}
            weight="regular"
            style={{ position: 'absolute', right: 11.11, pointerEvents: 'none' }}
          />
        )}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          color: '#F2F2F3',
          borderRadius: '5.555px',
          height: '38.85px',
          fontFamily: '"Instrument Sans", sans-serif',
          fontSize: '13.33px',
          fontWeight: 400,
          lineHeight: 1.5,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.2)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.3)',
          },
          '& .MuiSelect-select': {
            py: '5.555px',
            px: '11.11px',
            pr: '33px !important',
            fontSize: '13.33px',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-icon': {
            color: '#F2F2F3',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#1e1e20',
              '& .MuiMenuItem-root': {
                color: '#F2F2F3',
                '&.Mui-disabled': {
                  opacity: 0.5,
                },
              },
            },
          },
        }}
      >
        {SPORTS_OPTIONS.map((sport) => (
          <MenuItem
            key={sport.value}
            value={sport.value}
            disabled={sport.disabled}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>{sport.label}</span>
              {sport.disabled && (
                <Typography
                  component="span"
                  sx={{
                    fontSize: '11px',
                    color: 'rgba(242, 242, 243, 0.5)',
                    fontStyle: 'italic',
                    ml: 0.5,
                  }}
                >
                  Coming Soon
                </Typography>
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PropsSportsDropdown;
